import { useMemo } from 'react';

import type { PieArcDatum } from 'd3-shape';
import type { ProvidedProps } from '@visx/shape/lib/shapes/Pie';

import type { Datum, Fill } from '../../types';

import { Connector } from '../Connector';
import { Label } from '../Label';

import { INNER_RADIUS, OUTER_RADIUS } from '../../constants';

import { getPosition } from '../../utils';

interface Props {
  arc: PieArcDatum<Datum>;
  pie: ProvidedProps<Datum>;
  fill: Fill;
  width: number;
}

export const Annotation = ({ pie, arc, fill, width }: Props) => {
  const [outerElbowCentroidX, outerElbowCentroidY] = useMemo(() => {
    pie.path.innerRadius(OUTER_RADIUS);
    pie.path.outerRadius(OUTER_RADIUS + 80);
    return pie.path.centroid(arc);
  }, [pie, arc]);

  const [centroidX, centroidY] = useMemo(() => {
    pie.path.innerRadius(INNER_RADIUS);
    pie.path.outerRadius(OUTER_RADIUS);
    return pie.path.centroid(arc);
  }, [pie, arc]);

  const position = getPosition(centroidX);

  const outerTargetCentroidX = position === 'left' ? -(width / 2) : width / 2;
  return (
    <>
      <Connector
        x1={centroidX}
        y1={centroidY}
        x2={outerElbowCentroidX}
        y2={outerElbowCentroidY}
        x3={outerTargetCentroidX}
        y3={outerElbowCentroidY}
      />
      <Label
        x={outerTargetCentroidX}
        y={outerElbowCentroidY}
        label={arc.data.label}
        weight={arc.data.allocation}
        fill={fill}
      />
    </>
  );
};
